import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=75285820&scoped=true"
import script from "./courseDetails.vue?vue&type=script&lang=js"
export * from "./courseDetails.vue?vue&type=script&lang=js"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=75285820&prod&lang=stylus&scoped=true"
import style1 from "./courseDetails.vue?vue&type=style&index=1&id=75285820&prod&lang=stylus&scoped=true"
import style2 from "./courseDetails.vue?vue&type=style&index=2&id=75285820&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75285820",
  null
  
)

export default component.exports